export default function () {
  return function (scope, element, attrs) {
    if (scope.$last) {
      // try{
      //   $('#product-slider').slick("unslick");
      //   $('#product-carousel').slick("unslick");
      // }catch(e){
      // }
      // productSlider();
    }
  };
}